export const PALETTE = [
  "#2f80c9",
  "#57c15d",
  "#e0a63a",
  "#b07fd8",
  "#4cc0c0",
  "#e0605f",
  "#7f8fb0",
  "#d98a4f",
  "#5c8ee6",
  "#8ec46b",
];

export const DEFAULT_STATE = {
  lang: "ru",
  dateKind: "plan",
  dateFrom: "",
  dateTo: "",
  filterSource: "",
  filterAddress: "",
  filterLocation: "",
  selectedId: null,
  playing: false,
  search: "",
  sortCol: "source_name",
  sortDir: 1,
};
